import {
  ApplicationsContract,
  UserApplicationAccessContract,
  UserSubTenantAccessContract,
  GroupApplicationMappingContract,
} from '@terra/shared-contracts-applications';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const applicationsClient = createTerraOrpcClient({
  contract: ApplicationsContract,
  serviceName: SERVICE_NAME,
});

export const userApplicationAccessClient = createTerraOrpcClient({
  contract: UserApplicationAccessContract,
  serviceName: SERVICE_NAME,
});

export const userSubTenantAccessClient = createTerraOrpcClient({
  contract: UserSubTenantAccessContract,
  serviceName: SERVICE_NAME,
});

export const groupApplicationMappingClient = createTerraOrpcClient({
  contract: GroupApplicationMappingContract,
  serviceName: SERVICE_NAME,
});
